import { render, staticRenderFns } from "./TourPlacementCombinationGroup.vue?vue&type=template&id=8ca785cc"
import script from "./TourPlacementCombinationGroup.vue?vue&type=script&lang=js"
export * from "./TourPlacementCombinationGroup.vue?vue&type=script&lang=js"
import style0 from "./TourPlacementCombinationGroup.vue?vue&type=style&index=0&id=8ca785cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports